import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getById } from "@insite/client-framework/Store/Data/DataState";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

export function getProductIsPurchasableOnWeb(state: ApplicationState, id: string | undefined) {
    const productState = getById(state.data.products, id).value;
    let isPurchasableOnWeb = true;

    if (productState !== undefined) {
        const isVariantParent = productState.isVariantParent;
        if (isVariantParent) {
            isPurchasableOnWeb = false;
        } else {
            isPurchasableOnWeb =
                productState.properties.nonPurchasableOnWeb === undefined ||
                productState.properties.nonPurchasableOnWeb.toLowerCase() === "false";  
        }
    }
    return isPurchasableOnWeb;
}

export function removeSitePrefix(prefixParameter: any, productNumber: string) {
    const prefix: string = prefixParameter;

    const productNumberText = productNumber.startsWith(prefix)
        ? productNumber.substring(prefix.length, productNumber.length)
        : productNumber;

    return productNumberText;
}

export function appendSitePrefix(prefixParameter: any, productNumber: string) {
    const prefix: string = prefixParameter;

    if (!productNumber.toLowerCase().startsWith(prefix.toLowerCase())) {
        return prefix + productNumber;
    }
    return productNumber;
}

export function getDiscontinuedStatus(state: ApplicationState, id: string | undefined) {
    const productState = getById(state.data.products, id).value;

    let discontinuedStatus = null;

    if (productState !== undefined) {
        if (!productState.isVariantParent) {
            discontinuedStatus =
                productState.properties.discontinuedStatus === undefined ||
                productState.properties.discontinuedStatus.toLowerCase();
        }
    }
    return discontinuedStatus;
}

export function getIsDiscontinued(state: ApplicationState, id: string | undefined) {
    const productState = getById(state.data.products, id).value;
    let isDiscontinued = false;

    if (productState !== undefined) {
        if (!productState.isVariantParent) {
            isDiscontinued =
                productState.properties.discontinuedStatus !== undefined &&
                productState.properties.discontinuedStatus.toLowerCase() === "discontinued";
        }
    }
    return isDiscontinued;
}

export function getIsTempNotForSale(state: ApplicationState, id: string | undefined) {
    const productState = getById(state.data.products, id).value;
    let isTempNotForSale = false;

    if (productState !== undefined) {
        if (!productState.isVariantParent) {
            isTempNotForSale =
                productState.properties.discontinuedStatus !== undefined &&
                productState.properties.discontinuedStatus.toLowerCase() === "temp not for sale";
        }
    }
    return isTempNotForSale;
}

export function getToBeDiscontinued(state: ApplicationState, id: string | undefined) {
    const productState = getById(state.data.products, id).value;
    let toBeDiscontinued = false;

    if (productState !== undefined) {
        if (!productState.isVariantParent) {
            toBeDiscontinued =
                productState.properties.discontinuedStatus !== undefined &&
                productState.properties.discontinuedStatus.toLowerCase() === "to be discontinued";
        }
    }
    return toBeDiscontinued;
}

export function getPartNumberChange(state: ApplicationState, id: string | undefined) {
    const productState = getById(state.data.products, id).value;
    let partNumberChange = false;

    if (productState !== undefined) {
        if (!productState.isVariantParent) {
            partNumberChange =
                productState.properties.discontinuedStatus !== undefined &&
                productState.properties.discontinuedStatus.toLowerCase() === "part number change";
        }
    }
    return partNumberChange;
}

export function getIsRentableProduct(state: ApplicationState, id: string | undefined) {
    const productState = getById(state.data.products, id).value;
    let isRentableProduct = false;

    if (productState !== undefined) {
        if (!productState.isVariantParent) {
            isRentableProduct =
                productState.properties.rentableProduct !== undefined &&
                productState.properties.rentableProduct.toLowerCase() === "true";
        }
    }
    return isRentableProduct;
}

export function isDropShipItem(product: ProductModel): boolean {
    const dropShipAttributeValue = product.attributeTypes
        ?.filter(a => a.name === "ItemDropShip")
        .map(a => a.attributeValues || [])
        .reduce((acc, currentValue) => [...acc, ...currentValue], [])
        .map(o => o.valueDisplay);

    if (!dropShipAttributeValue || dropShipAttributeValue.length === 0) {
        return false;
    }
    
    return dropShipAttributeValue.includes("Yes");
}

export function isDropShipItemFromProperties(product: any): boolean {
    return product.properties?.itemDropShip === "Yes";
}

export function hasInventory(state: ApplicationState, productContext: ProductContextModel | undefined) {
    if (!productContext || !productContext.productInfo) {
        return null;
    }

    const {
        productInfo: { inventory, unitOfMeasure },
    } = productContext;

    const inventoryAvailability = inventory?.inventoryAvailabilityDtos?.find(o => o.unitOfMeasure === unitOfMeasure);

    return inventoryAvailability?.availability;
}